import { CommonIdPurchases, CommonIdPurchasesPurchase } from '../../models/common-id/common-id-purchases';
import { PURCHASE_METHOD_NAMES } from '../../resources/common-id-config';

export class CommonIdPurchaseUtil {
  /**
   * 最終購入（purchasedAt が最大のもの）の決済方法名を返す。
   * 購入履歴がない場合や決済方法が未知の ID だった場合は undefined を返す。
   *
   * status では絞り込まない。commonIdPurchases は purchasedAt が
   * commonIdUsers.lastPurchasedAt と同じタイミングで書かれるため
   * （purchase-repository.save()）、status によらず最新を選べば
   * アカウント検索の「購入日時」列と同じレコードを指す。
   * 現行の Webhook は入金確定分しか保存しないが、過去データに
   * 支払い待ち（status: 2）が含まれていても同じ扱いにする。
   */
  static findLastPaymentMethodName(purchases: CommonIdPurchases): string | undefined {
    const lastPurchase = CommonIdPurchaseUtil.findLastPurchase(purchases);
    if (!lastPurchase) return undefined;

    const method = PURCHASE_METHOD_NAMES.find(it => it.id === lastPurchase.paymentMethod);
    return method ? method.name : undefined;
  }

  private static findLastPurchase(purchases: CommonIdPurchases): CommonIdPurchasesPurchase | undefined {
    if (!purchases || !purchases.purchases || purchases.purchases.length === 0) return undefined;

    // 保存順に依存しないよう purchasedAt が最大のものを選ぶ。
    // 同時刻が並んだ場合は commonIdUsers.lastPurchasedAt（最後に保存されたもの）に
    // 合わせるため、後ろの要素を優先する
    return purchases.purchases.reduce((last, it) => (it.purchasedAt >= last.purchasedAt ? it : last));
  }
}
